import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAppearanceLightMode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconAppearanceLightMode"><Path d="M12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8V16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5V16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8V3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAppearanceLightMode;
